// assets/controllers/profile/edit_working_hours_modal_controller.js

import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { Modal } from 'bootstrap';

const COUNTRY = window.country || 'fr'; // Set this from backend or JS context

export default class extends Controller {

    static values = {
        country: String,
    };

    connect() {

        this.modal = new Modal(
            this.element,
            {
                backdrop: 'static',
                focus: false,
                show: false,
            },
        );

        // The time pickers used to be set up for every page by the Hyper theme's hyper.js,
        // with these defaults (the element's data-* options win). Without it they only got
        // built when the clock icon was clicked, with Bootstrap 3 glyphicon arrows that this
        // app doesn't have (DDT-3772).
        $(this.element).find('[data-bs-toggle="timepicker"]').timepicker({
            showSeconds: true,
            icons: {
                up: 'mdi mdi-chevron-up',
                down: 'mdi mdi-chevron-down',
            },
        });

        $(this.element).one('shown.bs.modal', () =>
            this.initTimepickers(),
        );
    }

    openModal() {
        this.modal.show();
    }

    initTimepickers() {
        const $element = $(this.element);
        const $inputs = $element.find('[data-bs-toggle="timepicker"]');
        const country = this.countryValue;

        $element.find('.icon').off('click').on('click', function(event) {
            event.preventDefault();

            const $input = $(this).siblings('input[data-bs-toggle="timepicker"]');

            if ($input.length) {
                $input.timepicker('showWidget');
                $input.focus();
            }
        });

        $inputs.each((index, element) => {
            const $timeInput = $(element);

            if (country === 'gb' && $timeInput.val()) {
                $timeInput.val(this.formatGbTime($timeInput.val().trim()));
            }

            if (country === 'fr' || country === 'be') {
                if ($timeInput.val()) {
                    $timeInput.val(this.formatFrTime($timeInput.val()));
                }

                $timeInput.on('input', (e) => {
                    let val = e.target.value.replace(':', 'h').replace(/[^0-9h]/g, '');
                    let match = val.match(/^(\d{1,2})h(\d{2})?$/);

                    if (match) {
                        e.target.value = this.formatFrTime(val);

                    } else {
                        let hourMatch = val.match(/^(\d{1,2})h?$/);

                        if (hourMatch) {
                            e.target.value = `${hourMatch[1].padStart(2, '0')}h`;
                        } else {
                            e.target.value = val;
                        }
                    }
                });
            }

            $timeInput.on('changeTime.timepicker.__sync', (e) => {
                if ((country === 'fr' || country === 'be') && e.time && e.time.value) {
                    $timeInput.val(this.formatFrTime(e.time.value));
                } else if (country === 'gb' && e.time && e.time.value) {
                    $timeInput.val(this.formatGbTime(e.time.value.trim()));
                } else {
                    throw new Error('Invalid country code ' + country);
                }
            });
        });
    }

    save() {
        const $element = $(this.element);
        const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

        $element.find('[data-bs-toggle="timepicker"]').each(function() {
            try {
                $(this).timepicker('hideWidget');
            } catch {
            }

            $(this).trigger('change').trigger('blur');
        });

        const workingHoursData = {};

        for (const day of days) {
            let from = $element.find(`#${day}-from-input`).val()?.trim() || '09:00';
            let to = $element.find(`#${day}-to-input`).val()?.trim() || '18:00';
            const is_open = $element.find(`#${day}-checkbox`).prop('checked') ?? false;

            if (this.countryValue === 'fr' || this.countryValue === 'be') {
                from = from.replace('h', ':');
                to = to.replace('h', ':');
            } else if (this.countryValue === 'gb') {
                from = this.convertTo24Hour(from);
                to = this.convertTo24Hour(to);
            }

            workingHoursData[day] = { is_open, from, to };
        }

        showPreloader();

        $.ajax({
            url: routes['app_profile_editworkinghours'],
            method: 'POST',
            dataType: 'json',
            data: { value: JSON.stringify(workingHoursData) },
            success: (response) => {
                if (response.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            category: 'Account',
                            action: 'working_hours | Success',
                            label: GA_EVENT_LABEL,
                        },
                    });

                    window.location.reload();
                }
            },
            error: (error) => {
                const json = error.responseJSON;
                if (json?.message) return addAlert('danger', json.message);
                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            },
        });
    }

    convertTo24Hour(timeStr) {
        const match = timeStr.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!match) return timeStr;
        let hour = parseInt(match[1], 10);
        const minute = match[2];
        const meridian = match[3].toUpperCase();
        if (meridian === 'PM' && hour < 12) hour += 12;
        if (meridian === 'AM' && hour === 12) hour = 0;
        return `${hour.toString().padStart(2, '0')}:${minute}`;
    }

    formatFrTime(val) {
        val = val.replace(':', 'h');
        const match = val.match(/^(\d{1,2})h(\d{2})?$/);
        if (match) {
            const hour = match[1].padStart(2, '0');
            const minute = match[2] ? match[2] : '';
            return minute ? `${hour}h${minute}` : `${hour}h`;
        }
        return val;
    }

    formatGbTime(val) {
        const match = val.match(/^(\d{1,2}):(\d{2})$/);
        if (match) {
            let hour = parseInt(match[1], 10);
            const minute = match[2];
            const meridian = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12 || 12;
            return `${hour.toString().padStart(2, '0')}:${minute}${meridian}`;
        }
        return val;
    }
}
